var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookedTrip, Flight } from '@ibe/models';
import { BookingStep } from '@ibe/models/ui';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { takeWhile, map } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as BookingStepActions from '@ibe/store/actions/booking-steps.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as FlightResultActions from '@ibe/store/actions/flight-result.actions';
import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { BookingService } from '@ibe.services/booking.tap.service';
import { TRIP_TYPE_ROUND_TRIP_CODE, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_MULTICITY_CODE, EQUIPMENT_CODE_BUS, TTT_STATUS_ACTIVE, DISCOUNT_TYPE_VOUCHER, DISCOUNT_TYPE_PROMOCODE, DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_STATUS_ACTIVE } from '@ibe.config';
var INDRABookingPriceBreakdownComponent = /** @class */ (function () {
    function INDRABookingPriceBreakdownComponent(sidebarService, route, router, store, modalService, currencyService, bookingSearchService, bookingService, flightPriceService, ibeAdminService, bfmStorage, storage) {
        var _this = this;
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.store = store;
        this.modalService = modalService;
        this.currencyService = currencyService;
        this.bookingSearchService = bookingSearchService;
        this.bookingService = bookingService;
        this.flightPriceService = flightPriceService;
        this.ibeAdminService = ibeAdminService;
        this.bfmStorage = bfmStorage;
        this.storage = storage;
        this.isAlive = true;
        this.VOUCHER_DISCOUNT = DISCOUNT_TYPE_VOUCHER;
        this.PROMOCODE_DISCOUNT = DISCOUNT_TYPE_PROMOCODE;
        this.FIXED_TYPE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_FIXED;
        this.PERCENTAGE_TYPE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_PERCENTAGE;
        // Data
        this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.stopOvers$ = this.store.select(fromStore.getMiniIBEStopovers);
        this.stopOvers = [];
        this.bookingSteps$ = this.store.select(fromStore.getSelectedBookingSteps);
        this.userInfo$ = this.store.select(fromStore.getUserInfo);
        this.userInfo = false;
        this.bookedTripDiscounts$ = this.store.select(fromStore.getSelectedBookedTripDiscounts);
        this.bookedTripDiscounts = [];
        this.confirmModalCallback$ = this.store.select(fromStore.getConfirmModalConfirm);
        this.confirmModalCallback = '';
        this.promocoCodesAndVoucher$ = this.store.select(fromStore.getSelectedPromoVouchers);
        this.promocoCodesAndVoucher = [];
        this.weakFlightsDiscount$ = this.store.select(fromStore.getWeakFlightAmt);
        this.bookAwardFlights$ = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        //flightWithMiles$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterFlightWithMiles);
        //flightWithMiles: boolean;
        this.payingWithMiles = true;
        this.milesInFlightDiscount$ = this.store.select(fromStore.getMilesInFlightDiscount);
        this.milesSpent$ = this.store.select(fromStore.getTotalMilesToSpend);
        this.discountedBookingCost$ = this.store.select(fromStore.getDiscountedBookingCost);
        this.discountedBookingCost = 0;
        this.originalBookingCost$ = this.store.select(fromStore.getOriginalBookingCost);
        this.originalBookingCost = 0;
        this.noFlights = [];
        this.adminFee = 0;
        this.isTTTFlow = false; // time to think purchase (to save booking prices)
        this.isNormalBookingOrActiveTTT = false;
        this.flightInformation$ = this.store.select(fromStore.getFlightInformation);
        this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
        this.bookingSteps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.bookingSteps = value;
            }
        });
        this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookAwardFlights = value;
        });
        this.stopOvers$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.stopOvers = value;
        });
        this.bookedTrip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.booked_trip = value;
                _this.INDRA_generateFlights(_this.booked_trip);
                _this.isNormalBookingOrActiveTTT = _this.INDRA_isNormalBookingOrActiveTTT(_this.booked_trip);
            }
        });
        this.promocoCodesAndVoucher$
            .pipe(takeWhile(function () { return _this.isAlive; }), map(function (value) { return value && value.filter(function (discount) { return discount.status === DISCOUNT_STATUS_ACTIVE; }); }))
            .subscribe(function (discounts) {
            if (discounts && discounts.length != 0) {
                _this.promocoCodesAndVoucher = Object.assign([], discounts);
            }
            else {
                _this.promocoCodesAndVoucher = [];
            }
        });
        this.confirmModalCallback$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.confirmModalCallback = value;
            }
        });
        this.bookedTripDiscounts$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (discounts) {
            _this.bookedTripDiscounts = Object.assign([], discounts);
        });
        this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.userInfo = value;
                _this.isLoggedIn = true;
            }
            else {
                _this.isLoggedIn = false;
            }
        });
        this.weakFlightsDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value != null) {
                _this.weakFlightsDiscount = value;
            }
        });
        /*
        this.flightWithMiles$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.flightWithMiles = value;
            });
        */
        this.milesInFlightDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.milesInFlightDiscount = value;
            }
        });
        this.milesSpent$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.milesSpent = value;
            _this.payingWithMiles = _this.milesSpent > 0 ? true : false;
        });
        this.discountedBookingCost$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.discountedBookingCost = value;
        });
        this.originalBookingCost$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.originalBookingCost = value;
        });
        this.flightInformation$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                if (value && value.flight.flight) {
                    if (_this.booked_trip.flights.length === 0) {
                        _this.booked_trip = __assign({}, _this.booked_trip, { flights: [] });
                        _this.booked_trip.flights.push(value.flight.flight);
                        _this.INDRA_generateFlights(_this.booked_trip);
                    }
                    else if (_this.booked_trip.booking_type === TRIP_TYPE_ROUND_TRIP_CODE) {
                        var isInbound = value.flight.flight.bound === 'inbound';
                        if (isInbound && _this.booked_trip.flights.length === 1) {
                            ;
                            _this.booked_trip = __assign({}, _this.booked_trip, { flights: _this.booked_trip.flights.concat(value.flight.flight) });
                        }
                        _this.INDRA_generateFlights(_this.booked_trip);
                    }
                    _this.isNormalBookingOrActiveTTT = _this.INDRA_isNormalBookingOrActiveTTT(_this.booked_trip);
                }
            }
        });
    }
    INDRABookingPriceBreakdownComponent.prototype.ngOnInit = function () {
        this.isTTTFlow = this.router.url.includes('/time-to-think') ? true : false;
        if (this.router.url.includes('/review-your-trip') || this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think') || this.router.url.includes('/extras-to-your-trip')) {
            var pnrDetails = this.bfmStorage.originalPNRDetailsResponse;
            this.adminFee = pnrDetails && pnrDetails.data.fare && pnrDetails.data.fare.originalFlightPrice
                && pnrDetails.data.fare.originalFlightPrice.totalPrice && pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee
                && pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee.amount ?
                pnrDetails.data.fare.originalFlightPrice.totalPrice.adminFee.amount : 0;
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        this.booked_trip = null;
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_generateFlights = function (booked_trip) {
        this.noFlights = [];
        if (booked_trip.flights.length) {
            if (booked_trip.booking_type === TRIP_TYPE_ONE_WAY_CODE ||
                booked_trip.booking_type === TRIP_TYPE_MULTICITY_CODE) {
                if (booked_trip.flights.length === 0) {
                    this.noFlights.push(0);
                }
            }
            else if (booked_trip.booking_type === TRIP_TYPE_ROUND_TRIP_CODE) {
                var diff = 2 - booked_trip.flights.length;
                for (var i = 0; i < diff; i++) {
                    this.noFlights.push(i);
                }
            }
        }
        else {
            if (booked_trip.booking_type === TRIP_TYPE_MULTICITY_CODE ||
                booked_trip.booking_type === TRIP_TYPE_ONE_WAY_CODE ||
                this.stopOvers && this.stopOvers.length > 0) {
                this.noFlights.push(0);
            }
            else {
                this.noFlights.push(0);
                this.noFlights.push(1);
            }
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_printFlightDate = function (flight) {
        if (flight) {
            var date = moment(new Date(flight.listSegment[0].departureDate.slice(0, -5)));
            var dateTime = date.format('D - kk:mm');
            var day = date.format('dddd').toLowerCase();
            var month = date.format('MMMM').toLowerCase();
            day = this.INDRA_getTranslation('dates.text.' + day);
            month = this.INDRA_getTranslation('dates.text.' + month);
            return day.substring(0, 3) + ", " + month.substring(0, 3) + " " + dateTime;
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_handleFareAndTaxes = function () {
        var fareTaxesParams = {
            isDupe: false,
            isTTTBookingForCompletion: false
        };
        this.sidebarService.openSidebar(['fare-and-taxes', fareTaxesParams]);
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_handleVoucherOrPromocode = function () {
        this.sidebarService.openSidebar(['voucher-or-promocode']);
    };
    /**
     * Handles a back event from the context menu
     */
    INDRABookingPriceBreakdownComponent.prototype.INDRA_handleBack = function () {
        var _this = this;
        this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('priceBreakdown.text.backToSelection')));
        this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('priceBreakdown.text.ifYouContinue')));
        this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('priceBreakdown.text.dontLeavePage')));
        this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('priceBreakdown.text.chooseFlightsAgain')));
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();
        this.modalService.isOpen
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (!value) {
                if (_this.confirmModalCallback === 'ok') {
                    _this.store.dispatch(new ConfirmModalActions.ResetAction());
                    if (_this.booked_trip.stopover) {
                        _this.router.navigate(['/booking/flights-stopover']);
                    }
                    else {
                        if (_this.booked_trip.booking_type === TRIP_TYPE_MULTICITY_CODE) {
                            _this.router.navigate(['/booking/flights-multicity']);
                        }
                        else {
                            _this.router.navigate(['/booking/flights']);
                        }
                    }
                    _this.closeSidebar();
                    _this.INDRA_clearBookedTrip();
                }
            }
        });
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRABookingPriceBreakdownComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
    };
    /**
     * Clear selected dates
     */
    INDRABookingPriceBreakdownComponent.prototype.INDRA_clearBookedTrip = function () {
        var auxArray = [];
        this.bookingSteps.forEach(function (step) { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });
        var booked_trip = Object.assign(new BookedTrip([], this.booked_trip.pnr, this.booked_trip.booking_type), this.booked_trip);
        booked_trip.emptyFlights();
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trip));
        this.store.dispatch(new BookingStepActions.PutStepsAction(auxArray));
        this.store.dispatch(new BookingStepActions.PutCurrentStepAction(0));
    };
    /** Handles close action intention **/
    INDRABookingPriceBreakdownComponent.prototype.INDRA_handleClose = function () {
        this.closeSidebar();
    };
    INDRABookingPriceBreakdownComponent.prototype.showLoginModal = function () {
        this.modalService.assignComponent(INDRALoginModalComponent);
        this.modalService.open();
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_handleSignUp = function () {
        this.sidebarService.openSidebar(['sign-up']);
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_printAirlineLogo = function (flights) {
        if (flights) {
            var busSegmentCount = flights.listSegment.filter(function (segment) { return segment.equipment === EQUIPMENT_CODE_BUS; }).length;
            if (busSegmentCount > 0) {
                this.airlineLogo = 'Bus';
                return 'icons.svg#plane_related--plane_and_bus';
            }
            else {
                if (flights.listSegment.length > 1) {
                    var ALL_SAME_AIRLINE = flights.listSegment.every(function (val, i, arr) { return val.operationCarrier === arr[0].operationCarrier; });
                    if (ALL_SAME_AIRLINE) {
                        this.airlineLogo = flights.listSegment[0].operationCarrier;
                    }
                    else {
                        this.airlineLogo = 'Multiple';
                    }
                }
                else {
                    this.airlineLogo = flights.listSegment[0].operationCarrier;
                }
                return this.bookingSearchService.INDRA_buildAirlineLogoName(this.airlineLogo);
            }
        }
        else {
            this.airlineLogo = 'not_found';
            return this.bookingSearchService.INDRA_buildAirlineLogoName(this.airlineLogo);
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_hasBookedTrip = function () {
        if (this.noFlights.length == 0 && this.booked_trip.flights.length) {
            return true;
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_getPrice = function (priceOf) {
        switch (priceOf) {
            case 'flights':
                return this.INDRA_getFlightTotalCost();
            case 'discounts':
                return this.flightPriceService.INDRA_getDiscountsTotal(this.promocoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights, this.currency);
            case 'otherCharges':
                return this.flightPriceService.INDRA_getOtherChargesTotal();
            case 'finalAmountWithDiscountsAndNoMilesGo':
                return this.flightPriceService.INDRA_getBookingTotalCost(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights, true, this.promocoCodesAndVoucher, this.bookedTripDiscounts, this.weakFlightsDiscount, [], [], 0);
            default:
                return '';
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_getFlightPrice = function (flight) {
        return this.flightPriceService.INDRA_getFlightTotalCost(flight, this.booked_trip.booking_type, this.bookAwardFlights);
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_isUserLoggedIn = function () {
        this.userData = this.storage.get('userData');
        if (this.userData != null) {
            return true;
        }
        return false;
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_getFlightTotalCost = function () {
        if (this.milesInFlightDiscount && this.milesInFlightDiscount.miles && this.milesInFlightDiscount.cash) {
            var flightTotalPrice = this.flightPriceService.computeSelectedFlightsTotalPrice(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);
            if (this.isLoggedIn) {
                return this.INDRA_formatMiles(this.milesInFlightDiscount.miles) + ' + ' + this.INDRA_formatCash(flightTotalPrice - this.milesInFlightDiscount.cash);
            }
            else {
                return this.INDRA_formatCash(flightTotalPrice);
            }
        }
        else {
            return this.flightPriceService.INDRA_getSelectedFlightsTotalCost(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_printOriginalPrice = function () {
        // return this.INDRA_formatCash(this.originalBookingCost);
        return this.flightPriceService.INDRA_getBookingTotalCost(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights, true, [], [], [], [], [], 0);
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_printMiles = function () {
        return this.INDRA_formatMiles(this.milesSpent);
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_printFinalPrice = function () {
        if (this.milesInFlightDiscount && this.milesInFlightDiscount.miles && this.milesInFlightDiscount.cash) {
            var flightTotalPrice = this.flightPriceService.computeSelectedFlightsTotalPrice(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);
            if (this.isLoggedIn) {
                return this.INDRA_formatCash(flightTotalPrice - this.milesInFlightDiscount.cash);
            }
            else {
                return this.INDRA_formatCash(flightTotalPrice);
            }
        }
        if (this.payingWithMiles) {
            return this.INDRA_formatCash(this.discountedBookingCost);
        }
        else {
            return this.INDRA_printOriginalPrice();
        }
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_formatMiles = function (value) {
        return value.toFixed(0) + ' M';
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_formatCash = function (value, currency) {
        var currencyToDisplay = currency ? currency : this.currency;
        return value.toFixed(2) + ' ' + currencyToDisplay;
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_isNormalBookingOrActiveTTT = function (bookedTrip) {
        return (!bookedTrip || !bookedTrip.time_to_think || !bookedTrip.time_to_think.status || bookedTrip.time_to_think.status === TTT_STATUS_ACTIVE);
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRABookingPriceBreakdownComponent.prototype.INDRA_handleDetailsClick = function (flight) {
        this.store.dispatch(new FlightResultActions.PutSelectedFlightAction(Object.assign(new Flight(null, null, null), flight)));
        this.sidebarService.openSidebar(['flight-details', { flight: flight.listSegment[0].flightNumber, mode: 'search' }]);
    };
    return INDRABookingPriceBreakdownComponent;
}());
export { INDRABookingPriceBreakdownComponent };
